<template>
  <LinkButton
    type="button"
    tag="button"
    asterix
    @click="open"
  >
    *
  </LinkButton>
</template>

<script setup lang="ts">
import { LinkButton } from '@i22team/td-longtail-vue-components';
import { openModal } from '~/composables/modal';

const open = (e) => {
  e.preventDefault();
  openModal({
    heading: 'Aktionsbedingungen',
    closeOnBackdrop: true,
    content:
      'Die Gutschrift erfolgt in Höhe der ersten durchgeführten Transaktion mit „Zahl einfach per Handyrechnung“ nach Registrierung bis max. 5 €. Die Gutschrift erfolgt nach Ablauf einer etwaigen 14-tägigen Widerrufsfrist auf der gleichen Mobilfunkrechnung, auf der auch die qualifizierenden Käufe abgerechnet werden, oder auf der darauffolgenden Mobilfunkrechnung. Bei Widerruf einer qualifizierenden Bezahlung erfolgt keine Gutschrift, sofern im Aktionszeitraum keine andere qualifizierende Bezahlung mit „Zahl einfach per Handyrechnung“ getätigt wurde. Pro Kunde ist nur eine Gutschrift einlösbar.<br><br>' +
      'Ein Angebot von: Telekom Deutschland GmbH, Landgrabenweg 149, 53227 Bonn.<br>' +
      'Änderungen und Irrtümer vorbehalten.<br><br>',
  });
};
</script>
